import { CommonMsgNodeProps, ImageMessageType } from '@/types/message'
import styles from './index.module.scss'
import { Image } from 'antd'
import fallBackPng from '@/assets/images/loading.gif'
interface ImageMsgProps extends CommonMsgNodeProps {
  node: ImageMessageType
  typing?: boolean
}

const ImageMsg = (props: ImageMsgProps) => {
  const { node } = props
  const { value, display = 'block' } = node

  const isBlockLayout = display === 'block'
  const style = {
    display: isBlockLayout ? 'flex' : 'inline'
  }

  const images = value?.imgs || []

  if (images.length === 0) {
    return null
  }

  const placeholder = <Image preview={false} src={fallBackPng} />

  return (
    <div className={styles.container} style={style}>
      <div className={styles.imgBox}>
        {images?.map((img, index) => (
          <Image
            placeholder={placeholder}
            fallback={fallBackPng}
            key={index}
            className={styles.img}
            src={img}
            alt="image"
            // style={{
            // objectFit: 'cover'
            // }}
            // height={800}
          />
        ))}
      </div>
    </div>
  )
}

export default ImageMsg
